import 'src/styles/ui/upload-dropzone.css';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import iconNode from 'src/components/ui/iconNode';

/**
 * A file-upload dropzone. In its idle state it renders as a `<label>` (pass
 * `htmlFor` to trigger a hidden file input placed in `children`) with an icon,
 * label and optional hint. Pass a numeric `progress` (0-100) to switch to the
 * busy state: a progress bar instead of the prompt. Generic — usable by any
 * feature. `icon` accepts a FontAwesome definition or a node.
 */
const UploadDropzone = ({
  htmlFor,
  icon,
  label,
  hint,
  progress,
  children,
  className,
  ...props
}) => {
  if (progress != null) {
    return (
      <div className={classNames('upload-dropzone upload-dropzone--busy', className)} {...props}>
        <span className='upload-dropzone__label'>
          {label || `Uploading… ${Math.round(progress)}%`}
        </span>
        <span className='upload-dropzone__track'>
          <span className='upload-dropzone__bar' style={{ width: `${progress}%` }} />
        </span>
      </div>
    );
  }
  return (
    <label htmlFor={htmlFor} className={classNames('upload-dropzone', className)} {...props}>
      {icon != null && <span className='upload-dropzone__iconwrap'>{iconNode(icon)}</span>}
      {label != null && <span className='upload-dropzone__label'>{label}</span>}
      {hint != null && <span className='upload-dropzone__hint'>{hint}</span>}
      {children}
    </label>
  );
};

UploadDropzone.propTypes = {
  htmlFor: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.object, PropTypes.node]),
  label: PropTypes.node,
  hint: PropTypes.node,
  progress: PropTypes.number,
  children: PropTypes.node,
  className: PropTypes.string,
};

UploadDropzone.defaultProps = {
  htmlFor: null,
  icon: null,
  label: null,
  hint: null,
  progress: null,
  children: null,
  className: '',
};

export default UploadDropzone;
